import React, { useState, useEffect } from 'react';
import './App.css';
import './styles/dashboard-enhanced.css';
import './styles/sidebar-fixed.css';
import './styles/language-selector.css';
import './styles/page-header.css'; // Componente PageHeader unificado
import './styles/layout-fix.css'; // Fixes generales de layout
import './styles/sidebar-logo-fix.css'; // DEBE SER EL ÚLTIMO - Fix logo circular y selector idioma
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ClientProvider } from './contexts/ClientContext';
import { CampaignProvider } from './contexts/CampaignContext';
import Sidebar from './components/Sidebar';
import AnalyticsPanel from './components/AnalyticsPanel';
import AgentAnalyticsPanel from './components/AgentAnalyticsPanel';
import CampaignsPanel from './components/CampaignsPanel';
import ConversationsPanel from './components/ConversationsPanel';
import InformesPanel from './components/InformesPanel';
import ReportsPanel from './components/ReportsPanel';
import OSINTPanel from './components/OSINTPanel';
import QualityPlanPanel from './components/QualityPlanPanel';
import AdminConsole from './components/AdminConsole';
import Footer from './components/Footer';
import LoginV2 from './components/LoginV2';
import ResetPassword from './components/ResetPassword';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div style={{ fontSize: "3vh", color: "#0c2c6c", fontWeight: "700" }}>Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const Dashboard = () => {
  const { user, client } = useAuth();
  const [activePanel, setActivePanel] = useState(null);

  useEffect(() => {
    // Establecer panel inicial según secciones habilitadas
    const defaults = {
      'agent_analytics': false,
      analytics: false,
      informes: false,
      campaigns: false,
      conversations: false,
      reports: false,
      reports: false,
      osint: false,
      quality_plan: true
    };
    let enabled = defaults;
    if (client && client.enabled_sections) {
      try {
        const parsed = typeof client.enabled_sections === 'string'
          ? JSON.parse(client.enabled_sections)
          : client.enabled_sections;
        // Mezclar defaults con valores configurados para que claves faltantes hereden defaults
        enabled = { ...defaults, ...parsed };
      } catch (e) {
        console.error('Error parsing enabled_sections:', e);
        enabled = defaults;
      }
    }
    const order = ['analytics', 'informes', 'agent_analytics', 'campaigns', 'conversations', 'reports', 'osint', 'quality_plan'];
    const firstEnabled = order.find(key => enabled[key]);
    setActivePanel(firstEnabled || 'campaigns');
  }, [client]);

  // Redirigir admins al panel de administración
  if (user?.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  const renderActivePanel = () => {
    if (!activePanel) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-white">Cargando...</div>
        </div>
      );
    }
    switch (activePanel) {
      case 'analytics':
        return <AnalyticsPanel />;
      case 'informes':
        return <InformesPanel />;
      case 'agent_analytics':
        return <AgentAnalyticsPanel />;
      case 'campaigns':
        return <CampaignsPanel />;
      case 'conversations':
        return <ConversationsPanel />;
      case 'reports':
        return <ReportsPanel />;
      case 'osint':
        return <OSINTPanel />;
      case 'quality_plan':
        return <QualityPlanPanel />;
      case 'clients':
      case 'settings':
        return <AdminConsole />;
      default:
        return <CampaignsPanel />;
    }
  };

  return (
    <div className="app-container dashboard-container">
      <Sidebar activePanel={activePanel} setActivePanel={setActivePanel} />
      <main className="main-content main-content-enhanced">
        {renderActivePanel()}
        <Footer />
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ClientProvider>
          <CampaignProvider>
            <LanguageProvider>
              <Routes>
                <Route path="/login" element={<LoginV2 />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminConsole />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                {/* Rutas no definidas (ej. /api/health) → redirigir a raíz; la API está en el backend (puerto 8000) */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </LanguageProvider>
          </CampaignProvider>
        </ClientProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;